/**
 * Today's "Needs help" (core helprequest.ts H5): a teammate tapped "Get help" on a step, and it names where. It stays here until
 * someone taps "On my way" or "Handled", then it leaves everyone's Today and the person who asked is told. A link opens that same
 * guide at that step. Nothing when nothing is open, and never in a home.
 */
import { useEffect } from "react";
import { isHomeOrg } from "../api.ts";
import { useLoad } from "../lib/useLoad.ts";
import { useApi, useSession } from "../session.tsx";
import { Icon } from "./Icons.tsx";
import { Button, Card, LinkButton, Section } from "./ui.tsx";

export function NeedsHelp({ version = 0 }: { version?: number }) {
  const api = useApi();
  const s = useSession();
  const home = isHomeOrg(s.org);
  const list = useLoad(() => (home ? Promise.resolve(null) : api.helpList(s.org.id, s.location.id).catch(() => null)), [api, s.org.id, s.location.id, home, version]);
  // New requests arrive while Today is open.
  useEffect(() => {
    if (home) return;
    const t = setInterval(() => { void list.reload(); }, 20_000);
    return () => clearInterval(t);
  }, [home, list.reload]); // eslint-disable-line react-hooks/exhaustive-deps
  const needs = list.data?.needs ?? [];
  if (!needs.length) return null;
  const answer = async (id: string, status: "on_my_way" | "handled") => { try { await api.helpHandle(s.org.id, id, status); } finally { await list.reload(); } };
  return (
    <Section title="Needs help" kicker={`${needs.length} waiting`} className="needs-help">
      <div className="stack-sm">
        {needs.map((n) => (
          <div key={n.id} data-testid="needs-help-row"><Card className="stack-sm">
            <p className="row"><Icon name="people" /><strong>{n.title}</strong></p>
            {!n.private && n.body && <p>{n.body}</p>}
            <div className="row">
              <Button variant="primary" icon="check" onClick={() => void answer(n.id, "on_my_way")}>Tell them I'm on my way</Button>
              <Button variant="secondary" icon="check" onClick={() => void answer(n.id, "handled")}>Mark as handled</Button>
              {!n.private && <LinkButton to={n.link.web} variant="quiet" icon="chevron" iconEnd>Open the step</LinkButton>}
            </div>
          </Card></div>
        ))}
      </div>
    </Section>
  );
}
